<template>
  <div class="text-area text-center">
    <div class="line-cart">
      <LineChart
        :chartData="modelValue.revenueByDays"
        :options="modelValue.optionsNoText"
        :key="key"
      />
    </div>
    <h2 class="bold-19 text-gradient mb-2 mt-3">
      {{ $t("home.soldProducts") }}
    </h2>
    <div class="bold-24 text-gradient">
      <EditOnClick
        :model-value="modelValue?.total?.success?.revenue"
        type="price"
        :editable="false"
      />
    </div>
  </div>
</template>
<script>
import { LineChart } from "vue-chart-3";
import EditOnClick from "../inputs/EditOnClick.vue";

export default {
  name: "Income",
  components: { EditOnClick, LineChart },
  props: {
    key: Number,
    modelValue: Object,
  },
  data() {},
};
</script>
